import { createAction } from "redux-actions";
import { takeLatest, put, select, call } from "redux-saga/effects";
import axios from "axios";
import moment from "moment";
import { queryParams } from "../../../../../../utils/queryParams";
import { getState } from "../../selector-util";

export const FETCH_CURRENT_USER =
  "sagas/attendance/averageClassSizeByInstructor/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS =
  "sagas/attendance/averageClassSizeByInstructor/FETCH_CURRENT_USER_SUCCESS";

export const FETCH_FILTERS_SUCCESS =
  "sagas/attendance/averageClassSizeByInstructor/FETCH_FILTERS_SUCCESS";
const RESET_FILTER = "sagas/attendance/averageClassSizeByInstructor/RESET_FILTER";
export const RESET_FILTER_SELECTED =
  "sagas/attendance/averageClassSizeByInstructor/RESET_FILTER_SELECTED";

export const FETCH_TILES_SUCCESS =
  "sagas/attendance/averageClassSizeByInstructor/FETCH_TILES_SUCCESS";

export const FETCH_CHART_SUCCESS =
  "sagas/attendance/averageClassSizeByInstructor/FETCH_CHART_SUCCESS";
export const UPDATE_CHART = "sagas/attendance/averageClassSizeByInstructor/UPDATE_CHART";

export const SET_UPDATES_LOADING =
  "sagas/attendance/averageClassSizeByInstructor/SET_UPDATES_LOADING";
export const UPDATE_PERIOD_TYPE =
  "sagas/attendance/averageClassSizeByInstructor/UPDATE_PERIOD_TYPE";
const UPDATE_TABLE_VIEW = "sagas/attendance/averageClassSizeByInstructor/UPDATE_TABLE_VIEW";
export const UPDATE_TABLE_VIEW_SELECTED =
  "sagas/attendance/averageClassSizeByInstructor/UPDATE_TABLE_VIEW_SELECTED";

export const SET_LOADING = "sagas/attendance/averageClassSizeByInstructor/SET_LOADING";
export const SET_FILTERS_DIRTY = "sagas/attendance/averageClassSizeByInstructor/SET_FILTERS_DIRTY";

export const SET_DATES = "sagas/attendance/averageClassSizeByInstructor/SET_DATES";
export const UPDATE_DATES = "sagas/attendance/averageClassSizeByInstructor/UPDATE_DATES";

export const UPDATE_CUSTOM_RANGE =
  "sagas/attendance/averageClassSizeByInstructor/UPDATE_CUSTOM_RANGE";

export const UPDATE_CLASS_TYPES =
  "sagas/attendance/averageClassSizeByInstructor/UPDATE_CLASS_TYPES";

export const UPDATE_CHART_TYPE = "sagas/attendance/averageClassSizeByInstructor/UPDATE_CHART_TYPE";

export const UPDATE_CHART_TYPE_SELECTED =
  "sagas/attendance/averageClassSizeByInstructor/UPDATE_CHART_TYPE_SELECTED";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateClassTypes: createAction(UPDATE_CLASS_TYPES),
  updateData: createAction(UPDATE_CHART),
  updateDates: createAction(UPDATE_DATES),
  updateChartType: createAction(UPDATE_CHART_TYPE),
  updatePeriodType: createAction(UPDATE_PERIOD_TYPE),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateTableView: createAction(UPDATE_TABLE_VIEW),
  resetFilters: createAction(RESET_FILTER)
};

export default function* watchTotalSalesRevenue() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(UPDATE_CHART_TYPE, updateChartType);
  yield takeLatest(UPDATE_CUSTOM_RANGE, updateCustomRange);
  yield takeLatest(UPDATE_TABLE_VIEW, updateTableView);
  yield takeLatest(RESET_FILTER, resetFilters);
}

export function getIds(data) {
  let ids = "";
  data.map((item) => {
    ids = ids + item.id + ",";
  });
  return ids;
}

function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  yield setDates();
  try {
    yield getAllData();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* setDates() {
  const endDate = yield select((state) => getState(state).currentUser.calendarEndDate);
  const startDate = moment(endDate).startOf("month").subtract(11, "months").format("YYYY-MM-DD");
  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

function* getAllData() {
  yield fetchFilters();
  yield fetchTiles();
  yield fetchChart();
}

function* getCommonApiParams() {
  let sagaArguments = yield select(
    ({
      averageClassSizeByInstructor: {
        currentUser: { organization_id, current_location_id, current_object_id },
        selectedRequestDates: { startDate, endDate },
        selectedFilters: { period_type, categories },
        chartTypes
      }
    }) => ({
      params: {
        organization_id,
        location_id: current_location_id,
        object_id: current_object_id,
        start_date: startDate,
        end_date: endDate,
        period_type: period_type.toLowerCase(),
        categories: getIds(categories)
      },
      chartUrl: chartTypes.selected.paramName
    })
  );
  const {
    params: { organization_id, object_id, location_id }
  } = sagaArguments;

  if (!organization_id || !object_id || !location_id) return;
  return sagaArguments;
}

function* fetchFilters() {
  const sagaArguments = yield getCommonApiParams();

  yield getAverageClassSizeByInstructorFilters(sagaArguments);
}

function* fetchTiles() {
  const sagaArguments = yield getCommonApiParams();
  yield getTiles(sagaArguments);
}

function* fetchChart() {
  let sagaArguments = yield getCommonApiParams();

  const filterParams = yield select((state) => getState(state).selectedFilters);

  let filterQueryParams = {};

  for (let key in filterParams) {
    const value = filterParams[key];
    if (Array.isArray(value)) {
      filterQueryParams = {
        ...filterQueryParams,
        [key]: value.length ? value.map((val) => val.id).join(",") : '""'
      };
    } else {
      filterQueryParams = { ...filterQueryParams, [key]: `${value}`.toLowerCase() };
    }
  }

  sagaArguments = {
    ...sagaArguments,
    params: { ...sagaArguments.params, ...filterQueryParams }
  };

  yield getChart(sagaArguments);
}

function* updateTableView({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: UPDATE_TABLE_VIEW_SELECTED, payload });
  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getAverageClassSizeByInstructorFilters(sagaArguments) {
  const { chartUrl, params } = sagaArguments;
  const url = `${queryParams.apiVersion}${chartUrl}/filters`;
  try {
    const response = yield call(axios.get, url, { params });

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data.filters });

    yield setDates();
  } catch (err) {
    console.error(err);
  }
}

function* getTiles(sagaArguments) {
  const { chartUrl, params } = sagaArguments;
  const url = `${queryParams.apiVersion}${chartUrl}/tiles`;
  try {
    const response = yield call(axios.get, url, { params });
    yield put({ type: FETCH_TILES_SUCCESS, payload: response.data });
  } catch (err) {
    console.error(err);
  }
}

function* getChart(sagaArguments) {
  const { chartUrl, params } = sagaArguments;
  const url = `${queryParams.apiVersion}${chartUrl}`;
  try {
    const response = yield call(axios.get, url, { params });

    yield put({ type: FETCH_CHART_SUCCESS, payload: response.data.data });
  } catch (err) {
    console.error(err);
  }
}

function* updateCustomRange() {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
}

function* updateData() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  try {
    yield fetchChart();
    yield fetchChart("table");
    yield fetchTiles();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateChartType({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: UPDATE_CHART_TYPE_SELECTED, payload });
  try {
    yield getAllData();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* resetFilters() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield setDates();
  yield put({ type: RESET_FILTER_SELECTED });

  try {
    yield getAllData();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}
